<ds-info-block>{{ props.text }}</ds-info-block>
